import { render, staticRenderFns } from "./authorization3.vue?vue&type=template&id=cc3b313c&scoped=true&"
import script from "./authorization3.vue?vue&type=script&lang=js&"
export * from "./authorization3.vue?vue&type=script&lang=js&"
import style0 from "./authorization3.vue?vue&type=style&index=0&id=cc3b313c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3b313c",
  null
  
)

export default component.exports